import { GeneralStyle } from '@website-builder/model/style/general-style';

export class AccordionStyle extends GeneralStyle {
  static normalize(styles: Partial<AccordionStyle>): AccordionStyle {
    const generalStyle = GeneralStyle.normalize(styles);
    const accordionStyle = new AccordionStyle();

    Object.assign(accordionStyle, generalStyle);

    return accordionStyle;
  }
}
